// @generated
// This file was automatically generated and should not be edited.
// Run `dev generate pipeline-frontend` to regenerate.

/* eslint-disable unused-imports/no-unused-imports */

// oxlint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import {ColumnTypeValidationFlag} from 'data-frames/util/validateColumnType';
// oxlint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import {LeafType} from 'data-types/benchling-type-def/BenchlingTypeDef';
// oxlint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import {PipelineStepDataKind, PipelineStepType} from 'graphql-client/__generated/graphqlGlobalTypes';
import {PipelineStepShape} from 'pipelines/StepShapeUtils';

export const EXPERIMENT_OPTIMIZATION_GENERATE_SEARCH_SPACE_STEP_SHAPES = [
  {
    stepType: PipelineStepType.EXPERIMENT_OPTIMIZATION_GENERATE_SEARCH_SPACE,
    isDeprecated: false,
    version: 0,
    inputDataShapes: {
      'Categorical design space': {
        systemName: 'Categorical design space',
        displayName: 'Categorical design space',
        kind: PipelineStepDataKind.DATASET,
        isMulti: false,
        isRequired: true
      },
      'Continuous design space': {
        systemName: 'Continuous design space',
        displayName: 'Continuous design space',
        kind: PipelineStepDataKind.DATASET,
        isMulti: false,
        isRequired: true
      }
    },
    outputDataShapes: {
      'Search space': {
        systemName: 'Search space',
        displayName: 'Search space',
        kind: PipelineStepDataKind.DATASET,
        isMulti: false,
        isRequired: true
      }
    },
    config: {
      categoricalDesignSpace: {
        kind: 'tableReference',
        required: false,
        inputDataName: 'Categorical design space',
        inputDataIndex: 0
      },
      continuousDesignSpace: {
        kind: 'tableReference',
        required: false,
        inputDataName: 'Continuous design space',
        inputDataIndex: 0
      }
    }
  }
] as const satisfies ReadonlyArray<PipelineStepShape>;
